import { DocWorkflowAnswerType, translate as t, type KeyWithEmptyFnParam } from "~utils";

import { Accordion } from "../accordion";

export function AccordionAnswer(props: Extract<DocWorkflowAnswerType, { type: "ACCORDION" }>) {
  const { accordions } = props;

  return (
    <div css={{ display: "flex", flexDirection: "column", gap: "var(--spacing-lg)" }}>
      {accordions.map((accordion) => (
        <Accordion
          key={accordion.label.text}
          label={t(accordion.label.text as KeyWithEmptyFnParam)}
          content={t(accordion.text as KeyWithEmptyFnParam)}
        />
      ))}
    </div>
  );
}
